import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';

@Component({
  selector: 'content-datepicker',
  templateUrl: './content-datepicker.component.html',
  styleUrls: ['./content-datepicker.component.css'],
})
export class ContentDatepickerComponent {

  @Input() public minDate: Date;
  @Input() public isOptional: boolean;
  @Output() public dateChange: EventEmitter<Date> = new EventEmitter();
  public utcDate: Date;

  public get valid(): boolean {
    return this.utcDate ? true : false;
  }

  public get invalid(): boolean {
    return !this.valid;
  }

  // HACK:
  // We need to display UTC time but Datepicker and Timepicker are using
  // local time. So as a workaround we add/subtract the timezone offset.
  // If it's dumb, but it works, it ain't dumb.
  public updateUtcDate(originalDate: Date): void {
    if (!originalDate) {
      return;
    }

    const date: Moment = moment(originalDate);
    date.add(-date.utcOffset(), 'minutes');

    this.utcDate = date.toDate();
  }

  public handleDateChange(date: Date): void { // tslint:disable-line
    this.utcDate = date;

    const newDate: Moment = moment(date);
    newDate.add(newDate.utcOffset(), 'minutes');

    this.dateChange.emit(newDate.toDate());
  }

  public get startDate(): string {
    if (!this.utcDate) {
      return '';
    }

    const date: Moment = moment(this.utcDate);
    return date.format('DD.MM.YYYY');
  }

  public resetDate(): void { // tslint:disable-line
    this.utcDate = undefined;
    this.dateChange.emit(null);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/content-datepicker/content-datepicker.component.ts